import React from 'react';
import { Price } from './price';
import { Trans } from '@ui/i18n/trans';
import clsx from 'clsx';
import { FormattedCurrency } from '@ui/i18n/formatted-currency';

interface FormattedPriceProps {
  price?: Omit<Price, 'id'>;
  variant?: 'slash' | 'separateLine';
  className?: string;
  priceClassName?: string;
  periodClassName?: string;
}
export function FormattedPrice({
  price,
  variant = 'slash',
  className,
  priceClassName,
  periodClassName,
}: FormattedPriceProps) {
  if (!price) return null;

  const translatedInterval = <Trans message={price.interval} />;
  const hasDiscount = !!price.compare_amount && price.compare_amount > price.amount;

  return (
    <div className="flex flex-col items-start justify-center gap-2">
      {hasDiscount && (
        <span className="line-through text-muted-foreground/60 font-normal text-sm mb-1">
          <FormattedCurrency
            value={price.compare_amount! / (price.interval_count ?? 1)}
            currency={price.currency}
          />
        </span>
      )}
      <div className={clsx('flex items-center gap-4', className)}>
        <div className={clsx(priceClassName, hasDiscount && 'text-green-600 font-bold')}>
          <FormattedCurrency
            value={price.amount / (price.interval_count ?? 1)}
            currency={price.currency}
          />
        </div>
        {variant === 'slash' ? (
          <div className={periodClassName}> / {translatedInterval}</div>
        ) : (
          <div className={periodClassName}>
            <Trans message="/" /> {translatedInterval}
          </div>
        )}
      </div>
    </div>
  );
}
